// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-location-dm) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
  margin-left: -13px;
  padding-inline-start: 19px;
}

.detail-form {
  height: 100%;
}

.remove-button {
  margin-left: 10px;
}

input, select, textarea {
  background-color: lightgray !important;
}

.form-select {
  margin-left: -4px;
}

.form-control {
  margin-left: -5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
